import { Injectable, Inject, Injector, forwardRef } from '@angular/core';
import { map } from 'rxjs/operators';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { FuncionService } from './funcion.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private newRouter: Router,
        public newFuncionService: FuncionService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.newFuncionService.currentUserValue;
        if (currentUser.session) {
            return true;
        }
        this.newRouter.navigate(['']);
        return false;
    }
}


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private newRouter: Router) {
        
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if(err.status === 401){
                localStorage.setItem('cerrarSesion', "true");
                this.newRouter.navigate(['']);
            }
            return throwError(err);
        }))
    }
}